export enum FeatureToggle {
  connectedStores = 'rt_connected_stores',
  notOnFile = 'rt_connected_stores_caper_not_on_file',
  inventoryIntelligence = 'rt_inventory_intelligence',
  staffBarcodeManagement = 'rt_caper_staff_barcode_management',
  staffBarcodeManagementRetailer = 'rt_caper_staff_barcode_management_retailer',
  caperDisableAuthorEmail = 'rt_caper_disable_author_email',
  caperTransactionsV2Pilot = 'rt_caper_transactions_v2_pilot',
  caperTransactionsV2Ga = 'rt_caper_transactions_v2_ga',
  caperTransactionsTlogsDownload = 'rt_caper_transactions_tlogs_download',
}
